import axios from "axios";

export function createRequestActioner({api, type, method = 'GET', path = '', data, onSuccess, onError, ...rest}) {
    return dispatch => {
        rest.onSuccess(success => {
            dispatch({type, data: success.data});
            if (onSuccess)
                onSuccess(success);
        });

        return createRequest(rest)
    };
}

export function createRequest({api, type, method = 'GET', path = '', data, onSuccess, onError}) {
    return api({method, url: path, data})
        .then(success => {
            if (onSuccess) onSuccess(success);
        })
        .catch(error => {
            if (onError) onError(error);
        });
}

export function createRequestGeneric() {
    return axios.create({
        baseURL: process.env.REACT_APP_URL_API
    });
}

export default function createRequestAuth() {

    const api = axios.create({
        baseURL: process.env.REACT_APP_URL_API,
        withCredentials: true
    });

    api.interceptors.request.use(function (config) {
        return config;
    }, function (error) {
        return Promise.reject(error); // Do something with request error
    });

    api.interceptors.response.use(function (config) {
        return config;
    }, function (error) {
        if(error.response === undefined || error.response.status === 302){
            window.location.href = process.env.REACT_APP_URL_API+'/redirect?url='+window.location.href
        }
        return Promise.reject(error);
    });

    return api;
}




// WEBPACK FOOTER //
// ./src/helpers/RequestHelper.js